import { useMutation } from "@apollo/client";

import { GqlProjectExportCreateInput } from "~/__generated__";
import { ProjectExportCreateDocument } from "~/shared/components/ProjectExportCreateForm/mutations.generated";

export default function useProjectExportCreate() {
    const [createProjectExport, { loading, error }] = useMutation(ProjectExportCreateDocument);

    return {
        createProjectExport: (input: GqlProjectExportCreateInput) => createProjectExport({ variables: { input } }),
        loading,
        error,
    };
}
